import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiClient, extractApiError } from '../../../api/axios';
import { API } from '../../../constants/api';

const initialState = {
  tabId: 'consultation',
  productNotes: [],
  consultations: [],
};

export const fetchProductNotes = createAsyncThunk('notes/fetchProductNotes', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.products.allComments);
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const fetchConsultations = createAsyncThunk('notes/fetchConsultations', async (_, { rejectWithValue }) => {
  try {
    const response = await apiClient.get(API.consultations.list);
    return response.data;
  } catch (error) {
    return rejectWithValue(extractApiError(error));
  }
});

export const notesSlice = createSlice({
  name: 'notes',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchProductNotes.fulfilled, (state, action) => {
      state.productNotes = action.payload;
    });
    builder.addCase(fetchConsultations.fulfilled, (state, action) => {
      state.consultations = action.payload.results;
    });
  },
  reducers: {
    setTabId: (state, { payload }) => {
      state.tabId = payload;
    },
  },
});

export const { setTabId } = notesSlice.actions;

export default notesSlice.reducer;
